import {Component} from 'preact';
import {Query} from 'react-apollo';
import {GetDistributorsForCountry} from '@services/ResourcesService/query.graphql';
import {client} from '@core/GraphQLProvider';
import Distributors from '@components/distributors/Distributors';
// import ResourcesService from '@services/ResourcesService'; // note - for importing mocks during dev

export const DistributorApp = ( {countryId} ) =>
    <Query
        client={client}
        variables={{countryId}}
        query={GetDistributorsForCountry}>
        {( {data, error, loading} ) => {
            if ( loading || error ) {
                return null;
            }

            let distributorCollection = data.distributorsForCountry;
            console.log( 'distributorCollection', distributorCollection );
            if ( !distributorCollection ) {
                return null;
            }

            return <Distributors list={distributorCollection}/>;
        }}
    </Query>;
